import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'
import { IJWTToken, JWTTokenService } from '@app/shared/services/jwt-token'

@Injectable()
export class RefreshTokenCommand {
  constructor(
    private httpClient: HttpClient,
    private jwtTokenService: JWTTokenService
  ) {}

  call(): Observable<IJWTToken> {
    const url = `${environment.api.app}/sessions/refresh`
    const accessToken = this.jwtTokenService.get()!.access_token
    const refreshToken = this.jwtTokenService.get()!.refresh_token

    const params = new FormData()
    params.append('access_token', accessToken)
    params.append('refresh_token', refreshToken)

    return this.httpClient.post<IJWTToken>(url, params)
  }
}
